import api from '../api.js';
import { resolveTenantId } from '../utils/tenantParams.js';
import { invalidatePlantProtectionStats } from '../utils/plantProtectionStatsCache';

export const plantProtectionStatsApi = {
  getStats: (params = {}) => {
    const tenantId = params.tenantId || resolveTenantId();
    return api.get('/plant-protection/stats', { params: { scope: 'protection', tenantId, ...params } });
  }
};

export { invalidatePlantProtectionStats };
